/** Who this tab is: GET /api/me under qk.me. A tab without an identity slot pins the one it got (the most recent
 * login in this browser), so a later login in another tab does not change who this tab is. */
import { useQuery } from "@tanstack/react-query";
import { api, type Schemas, unwrap } from "../api/client";
import { qk } from "../api/keys";
import { getSlot, setSlot } from "./identity";

type Scope = Schemas["Me"]["scopes"][number];

export async function fetchMe() {
  const me = await unwrap(api.GET("/api/me"));
  if (me.slot && !getSlot()) setSlot(me.slot);
  return me;
}

export function useMe() {
  return useQuery({ queryKey: qk.me, queryFn: fetchMe, retry: false });
}

/** Whether this tab's identity has `scope` (`admin` implies every scope, like the server's Actor.has). False while
 * /api/me is loading or failed, so write controls stay hidden until the identity is known. */
export function useScope(scope: Scope): boolean {
  const scopes = useMe().data?.scopes ?? [];
  return scopes.includes(scope) || scopes.includes("admin");
}
